'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _redux = require('redux');

// import multireducer from 'multireducer';

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _categories = require('./categories');

var _categories2 = _interopRequireDefault(_categories);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _subscribe = require('./subscribe');

var _subscribe2 = _interopRequireDefault(_subscribe);

var _details = require('./details');

var _details2 = _interopRequireDefault(_details);

var _posts = require('./posts');

var _posts2 = _interopRequireDefault(_posts);

var _post = require('./post');

var _post2 = _interopRequireDefault(_post);

var _sticky = require('./sticky');

var _sticky2 = _interopRequireDefault(_sticky);

exports['default'] = _redux.combineReducers({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  categories: _categories2['default'],
  search: _search2['default'],
  subscribe: _subscribe2['default'],
  details: _details2['default'],
  posts: _posts2['default'],
  post: _post2['default'],
  sticky: _sticky2['default']
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 683
// module chunks = 0